import { CurrencyPipe } from '@angular/common';
import { Column, GridRow } from '@shared';
export class ModifierException {
  @Column({
    title: 'Brink ID',
    field: 'parItemId',
    order: 0.2,
    width: 80,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    sortable: true,
  })
  parItemId?: string;

  @Column({
    field: 'plu',
    title: 'PLU',
    order: 1.9,
    width: 60,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    sortable: true,
    visibleInQuickView: true,
  })
  plu?: string;

  @Column({
    field: 'itemName',
    title: 'Product',
    order: 1,
    width: 200,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
    align: 'left',
  })
  itemName?: string;

  @Column({
    field: 'isActive',
    title: 'Is Active',
    order: 1.5,
    width: 80,
    filterable: true,
    filterType: 'boolean',
    type: 'boolean',
    sortable: true,
    visibleInQuickView: false,
    filterOptions: [
      { name: 'Yes', value: true },
      { name: 'No', value: false },
    ],
  })
  isActive?: boolean;

  @Column({
    field: 'panelName',
    title: 'Panel Name',
    order: 1,
    width: 200,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
    align: 'left',
  })
  panelName?: string;

  @Column({
    field: 'itemPrice',
    title: 'Current Price',
    order: 3.1,
    pipeToken: CurrencyPipe,
    width: 80,
    filterable: true,
    filterType: 'numeric',
    sortable: true,
    visibleInQuickView: true,
  })
  itemPrice?: number;

  @Column({
    field: 'modifierDiff',
    title: 'Modifier Diff',
    order: 3.2,
    pipeToken: CurrencyPipe,
    width: 80,
    filterable: true,
    filterType: 'numeric',
    sortable: true,
    visibleInQuickView: true,
  })
  modifierDiff?: number;

  @Column({
    title: 'No. of units',
    field: 'slicesNo',
    order: 3,
    width: 80,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    sortable: true,
  })
  slicesNo?: number;

  @Column({
    field: 'deliveryPrice',
    title: 'Current Delivery Price',
    order: 3.3,
    pipeToken: CurrencyPipe,
    width: 80,
    filterable: true,
    filterType: 'numeric',
    sortable: true,
    visibleInQuickView: true,
  })
  deliveryPrice?: number;

  @Column({
    field: 'deliveryModifierDiff',
    title: 'Delivery Modifier Diff',
    order: 3.4,
    pipeToken: CurrencyPipe,
    width: 80,
    filterable: true,
    filterType: 'numeric',
    sortable: true,
    visibleInQuickView: true,
  })
  deliveryModifierDiff?: number;

  restaurantId?: string;

  @Column({
    title: 'Restaurant',
    field: 'restaurantName',
    order: 0.1,
    width: 100,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    sortable: true,
    align: 'left',
  })
  restaurantName?: string;

  @Column({
    title: 'Tier',
    field: 'tierName',
    order: 0,
    width: 80,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    sortable: true,
    align: 'left',
  })
  tierName?: string;
  sortOrder?: number;

  constructor(modifierException?: Partial<ModifierException>) {
    this.itemName = modifierException?.itemName || '';
    this.parItemId = modifierException?.parItemId;
    this.plu = modifierException?.plu;
    this.itemPrice = modifierException?.itemPrice;
    this.isActive = modifierException?.isActive;
    this.panelName = modifierException?.panelName || '';
    this.modifierDiff = modifierException?.modifierDiff;
    this.slicesNo = modifierException?.slicesNo;
    this.deliveryPrice = modifierException?.deliveryPrice;
    this.deliveryModifierDiff = modifierException?.deliveryModifierDiff;
    this.restaurantId = modifierException?.restaurantId;
    this.sortOrder = modifierException?.sortOrder;
    this.tierName = modifierException?.tierName || '';
    this.restaurantName = modifierException?.restaurantName || '';
    this.deliveryPrice = modifierException?.deliveryPrice;
  }
}

export class GridRowModifierException extends GridRow(ModifierException) {}
